import store from '@webapp/store/index.js';

/**
 * Formats country from API to dropdown value
 *
 * @param {string} countryCode Country code from API CALL
 * @returns {object} Formatted country
 */
export function formatCountry(countryCode) {
    const country = store.getters['countries/countriesList'].find((country) => country.iso2 === countryCode);

    if (!country) {
        return null;
    }

    return {
        id: country.id,
        iso2: country.iso2,
        name: country.display,
    };
}